const actions = {
    PLAN_READ_ALL_REQUEST: 'PLAN_READ_ALL_REQUEST',
    PLAN_READ_ALL_SUCCESS: 'PLAN_READ_ALL_SUCCESS',
    PLAN_READ_ALL_FAILURE: 'PLAN_READ_ALL_FAILURE',

    PLAN_SET_BILLING_CYCLE: 'PLAN_SET_BILLING_CYCLE',

    PLAN_SET_PLAN: 'PLAN_SET_PLAN',
    PLAN_SET_ADD_ONS: 'PLAN_SET_ADD_ONS',
    PLAN_SET_ADD_ON: 'PLAN_SET_ADD_ON',

    PLAN_RESET: 'PLAN_RESET',

    readAll: request => ({
        type: actions.PLAN_READ_ALL_REQUEST,
        request,
    }),
    setBillingCycle: billingCycle => ({
        type: actions.PLAN_SET_BILLING_CYCLE,
        billingCycle,
    }),

    setSelectedPlan: plan => ({
        type: actions.PLAN_SET_PLAN,
        plan,
    }),

    setAddons: planAddons => ({
        type: actions.PLAN_SET_ADD_ONS,
        planAddons,
    }),
    setAddon: planAddon => ({
        type: actions.PLAN_SET_ADD_ON,
        planAddon,
    }),

    reset: () => ({
        type: actions.PLAN_RESET,
    }),
};
export default actions;
